"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.getCookie = exports.deleteCookie = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var setCookie = function setCookie(name, cookie, domain, expires) {
  document.cookie = "".concat(name, "=").concat(cookie, "; domain=").concat(domain, "; path=/; samesite=strict; expires=").concat(expires);
};

exports.setCookie = setCookie;

var getCookie = function getCookie(name) {
  var cookies = document.cookie.split(';').reduce(function (acc, cookieString) {
    var _cookieString$split$m = cookieString.split('=').map(function (s) {
      return s.trim();
    }),
        _cookieString$split$m2 = _slicedToArray(_cookieString$split$m, 2),
        key = _cookieString$split$m2[0],
        value = _cookieString$split$m2[1];

    if (key && value) {
      acc[key] = decodeURIComponent(value);
    }

    return acc;
  }, {});
  return name ? cookies[name] || '' : cookies;
};

exports.getCookie = getCookie;

var deleteCookie = function deleteCookie(name) {
  var date = new Date();
  date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
  document.cookie = "".concat(name, "=; expires=").concat(date.toUTCString(), "; path=/");
};

exports.deleteCookie = deleteCookie;